import { render } from "./TableOfContents.vue?vue&type=template&id=f2b8980e"
import script from "./TableOfContents.vue?vue&type=script&lang=js"
export * from "./TableOfContents.vue?vue&type=script&lang=js"

import "./TableOfContents.vue?vue&type=style&index=0&id=f2b8980e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__